import GroupWorkIcon from "@material-ui/icons/GroupWork";

import { OrderGroupEdit } from "./Edit/Edit";
import { OrderGroupsList } from "./List/List";

export { OrderGroupsList };

export const orderGroupsResource = {
	list: OrderGroupsList,
	edit: OrderGroupEdit,
	icon: GroupWorkIcon,
};
